// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavButton-cls1_gZm","cls2":"ImpactNavButton-cls2_AF8 ImpactNavButton-cls1_gZm"};